<div class="zimpler_toggle">
  <div class="updatepro_left--slider">
    <div class="overlay"></div>
    <div class="updatepro_left--container">
      

      <div class="updatepro_left--content">
        <!-- <div class="icon-close" (click)="Close()">&#x2715;</div> -->
        <div class="updatepro_left--content_heading myacc-pages-hdng">
          <h3 class="updatepro_left--title text-left">{{'zimpler.complete_profile1'| translate }}<br> {{ 'zimpler.complete_profile2'| translate }}
            <span class="back-icn" (click)="Close()"> <small>✕</small></span>
          </h3>
          
        </div>
        <div class="container-fluid">
          <p class="zimpler_toggle--desc text-left">{{'zimpler.complete_profile_desc'| translate }}</p>
          <form [formGroup]="updateCredentialsForm">
            <!-- email -->
            <div class="form-group" [ngClass]="getFormFiledClass('email',updateCredentialsForm)">
              <div class="controls">
                <input type="email" autocomplete="email" autocapitalize="off" formControlName="email" name="email"
                  class="floatLabel form-control" (focus)="onFocusForElement('email')"
                  (focusout)="onFocusOutForElement()" id="email" maxlength="64" />
                <label for="email">{{ 'registrationStepOne.emailAddress' | translate }}</label>
              </div>
              <div class="arrow_box "
                *ngIf="shouldShowErrors('email',updateCredentialsForm) && (updateCredentialsForm.controls['phone'].value || isSubmitted)">
                {{getErrorMessage('email',updateCredentialsForm)}} </div>
            </div>
            <!-- password -->
            <div class="form-group" [ngClass]="getFormFiledClass('password',updateCredentialsForm)">
              <div class="controls passwrd">
                <input autocomplete="new-password" [type]="viewPassword ? 'text' : 'password'"
                  formControlName="password" name="password" id="password" class="floatLabel form-control pwdFloatLabel"
                  (focus)="onFocusForElement('password')" (focusout)="onFocusOutForElement()"
                  (input)="trimPassowrd()" />
                <label for="password">{{ 'registrationStepOne.password' | translate }}</label>
              </div>
              <span class="pwd-show" [ngClass]="viewPassword ? 'eyeshow' : ''" (click)="viewPassword = !viewPassword"><i
                  class="icon-icon-eye"></i></span>
              <div 
                *ngIf="shouldShowPwdError('password',updateCredentialsForm) && (updateCredentialsForm.controls['password'].value || isSubmitted)"
                >
                <div class="arrow_box" *ngIf="focusPassword === true">
                  {{'phnumbertext.title' | translate}}
                </div>
                <div class="arrow_box" *ngIf="focusPassword !== true">
                  {{getErrorMessage('password',updateCredentialsForm)}}
                </div>
              </div>
              <!-- <div class="arrow_box_small passwrd_tooltip" *ngIf="shouldShowErrors('pwd',signUpStepOne)">{{getErrorMessage('pwd',signUpStepOne)}}</div> -->
            </div>

            <!-- phno -->
            <div class="form-group" [ngClass]="getFormFiledClass('phone',updateCredentialsForm)">
              <div class="tel-number controls" id="phoneNumberFlag">
                <input class="coutry-code form-control floatLabel inputWithoutDecimal" type="tel" autocomplete="tel-national"
                  formControlName="phone" name="phone" (focus)="onFocusForElement('phone')"
                  (focusout)="onFocusOutForElement()">
                <label for="phoneNumberFlag" class="phone">{{'updateprofileComp.updateprofile8' |
                  translate}}</label>
              </div>
              <div class="arrow_box_small"
                *ngIf="shouldShowMblErrors('phone',updateCredentialsForm) && (updateCredentialsForm.controls['phone'].value || isSubmitted)">
                {{getErrorMessage('phone',updateCredentialsForm)}}</div>
            </div>
            
            <div class="text-center">
              <button type="button" id="updateCredId"
                class="updateprf_changebtn btn-new site-btn site-btn__primary site-btn--lg"
                (click)="checkmobilereg(true)" [disabled]="getButtonDisabled(updateCredentialsForm)">
                <span>{{'zimpler.Start_playing' | translate}}</span>
              </button>
              <div *ngIf="message" class="successmsg align-center">{{'updateprofileComp.updateprofile11' | translate}}
              </div>
              <div class="Errormsg align-center" *ngIf="serverError">{{serverError}}</div>
            </div>
            <div class="clearfix"></div>
            <p class="zimpler_toggle--disc text-left" *ngIf="isShowDisclaimer">{{ 'zimpler.weeklyMonthlyLimits'| translate }} <a href="javascript:void(0)" (click)="toggleZDChat()">{{ 'zimpler.weeklyMonthlyLimits1'| translate }}</a></p>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

